import React from 'react'
import Creatable from 'react-select/creatable'

import {ControlProps, components} from 'react-select'
import styled from 'styled-components'

export const ControlPersistentLabel = (
  props: ControlProps & {selectProps: {customPlaceholder: string}}
) => {
  return (
    <>
      <Label isFloating={props.isFocused || props.hasValue}>
        {props.selectProps.customPlaceholder}
      </Label>
      {/* @ts-ignore https://github.com/JedWatson/react-select/issues/5955  */}
      <components.Control {...props} />
    </>
  )
}

const Label = styled.label.withConfig({
  shouldForwardProp: p => p !== 'isFloating'
})<{isFloating?: boolean}>`
  color: ${({theme}) => theme.grey35};
  left: 10px;
  pointer-events: none;
  position: absolute;
  transition: 0.1s ease all;
  -moz-transition: 0.1s ease all;
  -webkit-transition: 0.1s ease all;

  // put the label in the middle then at the top
  top: ${props =>
    props.isFloating ? `12px` : `calc(50% - ${props.theme.lineHeight} / 2)`};
  font-size: ${props =>
    props.isFloating ? props.theme.fontSizeS : props.theme.fontSize};
`

const SelectWithCustomPlaceholder = (
  props: Omit<React.ComponentProps<typeof Creatable>, 'unstyled'>
) => {
  const {placeholder, ...restProps} = props
  return (
    <Creatable
      components={{
        /* @ts-ignore https://github.com/JedWatson/react-select/issues/5955  */
        Control: ControlPersistentLabel as typeof components.Control
      }}
      // remove the default styles so we can style it ourselves
      unstyled
      // hide the built-in placeholder element (as we provide our own label)
      placeholder=""
      // this gets passed to our custom Control component
      // @ts-ignore defined on our ControlPersistentLabel
      customPlaceholder={placeholder}
      classNamePrefix="rs"
      {...restProps}
    />
  )
}

export const SelectCreatable = styled(SelectWithCustomPlaceholder)`
  .rs__control {
    height: 100%;
    background: ${({theme}) => theme.grey05};
    border-radius: ${({theme}) => theme.borderRadius};
    padding: 12px;
    width: 300px;
  }

  .rs__control--is-disabled .rs__dropdown-indicator {
    visibility: hidden;
  }

  .rs__select-container {
    background: ${({theme}) => theme.colors.grey3};
    margin-top: 2px;
    border-radius: ${({theme}) => theme.borderRadius};
    box-shadow: ${({theme}) => theme.shadowDepth1};
    overflow: hidden;
  }

  .rs__value-container {
    color: black;
    // sit at the bottom (avoid the label)
    align-self: end;
  }

  .rs__option {
    padding: 10px;
    background: white;
  }
  .rs__option--is-focused.rs__option {
    background: ${({theme}) => theme.colors.grey3};
  }

  .rs__no-options-message {
    padding: 10px;
  }
`
